import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const IntAssessHdrService = {
  getPayCycleType(obj) {
    return httpClient.post(endPoints.getPayCycleType, obj);
  },
  getAllStatus(obj) {
    return httpClient.post(endPoints.getAllStatus, obj);
  },
  getAllAssessTemp(obj) {
    return httpClient.post(endPoints.getAllAssessTemp, obj);
  },
  addAssessTemp(obj) {
    return httpClient.post(endPoints.addAssessTemp, obj);
  },
  updateAssessTemp(obj) {
    return httpClient.post(endPoints.updateAssessTemp, obj);
  },
  deleteAssessTemp(obj) {
    return httpClient.post(endPoints.deleteAssessTemp, obj);
  },
  getIntAssessHdrDetail(obj) {
    return httpClient.post(endPoints.getIntAssessHdrDetail, obj);
  },
  getAllIntAssessHdrList(obj) {
    return httpClient.post(endPoints.getAllIntAssessHdrList, obj);
  },
  getAllIntAssessHdrByCandIdAndJobCode(obj) {
    return httpClient.post(endPoints.getAllIntAssessHdrByCandIdAndJobCode, obj);
  },
  getAllCalendarData(obj) {
    return httpClient.post(endPoints.getAllCalendarData, obj);
  },
  getAllEnquiryIntAssessHdrList(obj) {
    return httpClient.post(endPoints.getAllEnquiryIntAssessHdrList, obj);
  },
  getAllEnquiryIntAssessHdrByJobCodeAndStatus(obj) {
    return httpClient.post(endPoints.getAllEnquiryIntAssessHdrByJobCodeAndStatus, obj);
  },
  getNewIntAssessHdrDetail(obj) {
    return httpClient.post(endPoints.getNewIntAssessHdrDetail, obj);
  },
  saveIntAssess(obj) {
    return httpClient.post(endPoints.saveIntAssess, obj);
  },
  saveIntSchedule(obj) {
    return httpClient.post(endPoints.saveIntSchedule, obj);
  },
  saveIntScheduleAndStaff(obj) {
    return httpClient.post(endPoints.saveIntScheduleAndStaff, obj);
  },
  updateIntSchedule(obj) {
    return httpClient.post(endPoints.updateIntSchedule, obj);
  },
  deleteIntAssess(obj) {
    return httpClient.post(endPoints.deleteIntAssess, obj);
  },
};

export default IntAssessHdrService;



// WEBPACK FOOTER //
// ./src/service/IntAssessHdrService.js